import React from 'react';

import { formatTime, timeToPixel } from '../utils/time-calculations';

type TimelineRulerProps = {
  durationSec: number;
  zoom: number;
  pixelsPerSecond: number;
  onSeek?: (timeSec: number) => void;
};

const SCALE_PARTS = 4;

export const TimelineRuler: React.FC<TimelineRulerProps> = ({
  durationSec,
  zoom,
  pixelsPerSecond,
  onSeek,
}) => {
  const tickTimes =
    durationSec > 0
      ? Array.from({ length: SCALE_PARTS + 1 }, (_, index) => {
          const ratio = index / SCALE_PARTS;
          return durationSec * ratio;
        })
      : [0];

  return (
    <div
      className="relative h-8 border-b border-spring-neutral-b0/15 bg-black/20"
      data-testid="timeline-ruler"
    >
      {tickTimes.map((second, index) => {
        const isLastTick = index === tickTimes.length - 1;
        const leftPx = timeToPixel(second, pixelsPerSecond, zoom);
        return (
          <button
            key={`tick-${index}-${second.toFixed(3)}`}
            type="button"
            className="absolute bottom-0 top-0 w-0 p-0 text-[10px] text-spring-neutral-b0/60"
            style={{ left: `${leftPx}px` }}
            onClick={() => onSeek?.(second)}
            aria-label={`timeline-ruler-tick-${index}`}
          >
            <span className="absolute bottom-0 top-0 left-0 w-px bg-spring-neutral-b0/15" />
            <span
              className={`absolute top-1 whitespace-nowrap ${
                isLastTick ? 'right-1 -translate-x-full text-right' : 'left-1'
              }`}
            >
              {formatTime(second)}
            </span>
          </button>
        );
      })}
    </div>
  );
};
